import styled from 'styled-components';

import { Table } from '@/components/Table';
import { scrollBarStyles } from '@/utils/theme';

export const Toolbar = styled.div`
  position: relative;
  z-index: 2;
  padding: 16px 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  background: ${({ theme }) => theme.colors.grayscaleLight};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
`;

export const Body = styled.div`
  padding: 16px 24px 24px;
  background: ${({ theme }) => theme.colors.grayscaleLight};
  height: min(560px, calc(100vh - 360px));
  min-height: 240px;
  overflow-y: auto;
  ${scrollBarStyles};
`;

export const StyledTable = styled(Table)`
  border-radius: 4px;
  overflow: hidden;

  th,
  td {
    &:first-child {
      padding-left: 24px;
    }

    &:last-child {
      padding-right: 24px;
      text-align: right;
    }
  }
`;
